import {useMemo} from 'react';
import cx from 'classnames';
import {UserAccountLinks} from '@/header/header-ctas';
import type {HeaderUser} from '../../types/components/header';
import Avatar, {AVATAR_SIZES, type AvatarVariant} from '../ui/avatar/index';
import styles from './user-dropdown-menu.module.scss';

const DROPDOWN_ARROW_SRC = '/static/images/ui/dropdown-arrow-green.svg';

interface UserDropDownMenuProps {
  user: HeaderUser;
  variant?: AvatarVariant;
  isOpen?: boolean;
  isDropdown?: boolean;
  onLogoutCb?: () => void | Promise<void>;
  onClickCb?: () => void;
}

const UserDropDownMenu = ({
  user,
  variant,
  isOpen = false,
  isDropdown = false,
  onLogoutCb = () => {},
  onClickCb = () => {}
}: UserDropDownMenuProps) => {
  const hideLinks = useMemo(() => !isOpen && !isDropdown, [isOpen, isDropdown]);
  const hideDropdown = useMemo(() => !isOpen && isDropdown, [isOpen, isDropdown]);

  if (hideDropdown) return null;

  return (
    <div className={styles['nav-user-dropdown']} onClick={onClickCb}>
      <div className={styles['nav-user-dropdown--header']}>
        <Avatar size={AVATAR_SIZES.LARGE} disableStates user={user} variant={variant} />
        <div className={styles['user-info-tile']}>
          <span className={styles['user-info-tile-name']} title={user.name}>
            {user.name}
          </span>
          <span className={styles['user-info-tile-subtitle']} title={user.email}>
            {user.email}
          </span>
        </div>

        <div
          className={cx(styles['user-dropdown-mobile-arrow'], {
            [styles['user-dropdown-mobile-arrow-active']]: isOpen
          })}
          aria-hidden>
          <img src={DROPDOWN_ARROW_SRC} alt="" width={11} height={8} />
        </div>
      </div>

      {hideLinks || (
        <>
          <div className={styles['user-into-tile-hr']} />
          <UserAccountLinks user={user} logout={onLogoutCb} />
        </>
      )}
    </div>
  );
};

export default UserDropDownMenu;
